// Import scripts
import './js/Report.js';

// Import CSS
import './scss/main.scss';

// Do on DOM ready
document.addEventListener( 'DOMContentLoaded', () => {});